module.exports = __webpack_public_path__ + "static/media/multiStyle_close_icon.eb44f17c.svg";